import React from "react";
import Fade from "react-reveal/Fade";
import { Element } from "react-scroll";

const Summary = props => {
  return (
    <Element name="about" className="headline__summary">
      <Fade left>
        <img src="/images/0.jpg" />
      </Fade>
      <Fade bottom>
        <div className="headline__summary--bio">
          <p>
            My name is Zak, I am a freelance front-end developer and former chef
            based in London, which basically means I love to eat while coding.
          </p>
          <p>
            I pride myself on writing concise yet readable code, solving
            problems and always strive to create the highest quality user
            experience possible. I'm told I have a genuine eye for aesthetics
            and enjoy the creative process.
          </p>
          <p>
            Although I specialise in front-end development, my knowledge of
            back-end development allows me to work on a project with the full
            scope in mind; simplifying the process of collaboration and
            producing a more cohesive experience for users.
          </p>
        </div>
      </Fade>
    </Element>
  );
};

export default Summary;



// WEBPACK FOOTER //
// ./src/component/Summary.js